import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { hasPermission } from "../../lib/permissions";
import type { Permission } from "../../types";

interface Props {
  permission: Permission;
  children: React.ReactNode;
  redirect?: string;
}

/**
 * Protege una ruta exigiendo un permiso especifico (o admin).
 * - Sin token -> /login.
 * - Con token pero sin user cargado todavia (`me()` en flight) -> render minimo
 *   para evitar flicker.
 * - Con user pero sin permiso -> redirect a /live.
 */
export function FlagProtectedRoute({ permission, children, redirect = "/live" }: Props) {
  const token = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (!user) {
    // Token presente pero user aun no resuelto (AppShell lo carga en mount).
    return <div className="p-4 text-muted text-sm">Cargando...</div>;
  }
  if (!hasPermission(user, permission)) {
    return <Navigate to={redirect} replace />;
  }
  return <>{children}</>;
}
